import React from 'react';
import { useParams } from "react-router-dom";
import { connect, useSelector } from 'react-redux';
import MetaTags from 'react-meta-tags';

import PagePL from './pc';

const mapStateToProps = (state) => {
    return { assetItem: state.asset.assetItem };
}

class SubPagePL extends React.Component{
	constructor(props){
		super(props)
	}
	
    render(){
		let project_link = '';
		if( this.props.assetItem['primary_content'] )
			project_link = <a href={ this.props.assetItem['primary_content'] } target="_blank">Open project in a new tab</a>
		
        return(
            <div className="description-box description-box-pa">
				<MetaTags>
					<title>{ this.props.assetItem['name'] + " | Tom Rice Portfolio 2025" }</title>
					<meta id="meta-description" name="description" content={ "Professional web development experience working on " + this.props.assetItem['name'] } />
					<meta id="og-title" property="og:title" content={ this.props.assetItem['name'] } />
					<meta id="og-image" property="og:image" content={ "//tjtrice.co.uk/images/" + this.props.assetItem['preview_image'] } />
				</MetaTags>
				<div className="container">
					<div className="image-container">
						<img src={ "//tjtrice.co.uk/images/" + this.props.assetItem['preview_image'] } />
					</div>
				</div>
				<div className="container">
					<div>{ this.props.assetItem['name'] }</div>
					<div>{ this.props.assetItem['date'] }</div>
					<div>{ this.props.assetItem['description'] }</div>
					{ project_link }
				</div>
            </div>
        );
    }
}

const ConnectedSubPagePL = connect( mapStateToProps )(SubPagePL)

export default ConnectedSubPagePL;